import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

import { TYPES } from '~/actions'
import Header from '~/components/Header'
import SubHeader from '~/components/Header/SubHeader'
import SegmentationFilter from '~/components/StoreList/SegmentationFilter'
import { selectSegmentation } from '~/selectors'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: theme.gofind.asideWidth,
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1000,
    left: 0,
    height: '100vh',
    overflow: 'hidden',
    boxShadow: theme.shadows[5],
    background: theme.palette.background.paper,
    transition: '.3s ease',
    transitionDelay: '.3s',
    boxShadow: 'none',
  },
  bar: {
    height: '100%',
    width: '100%',
    overflow: 'auto',
  },
  subHeader: {
    padding: 16,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  withHeaderBg: {
    paddingTop: 0,
    transition: 'none',
  },
  overlay: {
    width: theme.gofind.asideWidth,
    height: '100vh',
    background: '#000',
    position: 'fixed',
    opacity: 0.6,
    zIndex: 1001,
  },
}))

const views = [TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS, TYPES.VIEW_STORES]

function Sidebar({ view, children, position, config }) {
  const classes = useStyles()
  const withHeaderBg = [TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS].includes(view)
  const segmentation = useSelector(selectSegmentation)
  const hasSegmentation = !!Object.keys(segmentation || {}).length

  const [searchFieldHaveBeenFocus, setSearchFieldHaveBeenFocus] = useState(false)

  return TYPES.VIEW_EMPTY !== view ? (
    <Grid component="aside" className={cx(classes.wrapper, { [classes.withHeaderBg]: withHeaderBg })}>
      {searchFieldHaveBeenFocus && <Grid className={classes.overlay} />}

      <Grid>
        <Header
          config={config}
          position={position}
          searchFieldHaveBeenFocus={searchFieldHaveBeenFocus}
          setSearchFieldHaveBeenFocus={setSearchFieldHaveBeenFocus}
        />
        <SubHeader config={config} position={position} />
        {view === TYPES.VIEW_STORES && hasSegmentation && <SegmentationFilter />}
      </Grid>

      {views.map((key) =>
        view !== key ? null : (
          <SimpleBar className={classes.bar} key={key}>
            {children}
          </SimpleBar>
        ),
      )}

      {view === TYPES.VIEW_STORE_DETAILS && <Grid style={{ width: '100%' }}>{children}</Grid>}
    </Grid>
  ) : (
    <Header
      config={config}
      position={position}
      searchFieldHaveBeenFocus={searchFieldHaveBeenFocus}
      setSearchFieldHaveBeenFocus={setSearchFieldHaveBeenFocus}
    />
  )
}

export default Sidebar
